export const environment = {
  isStaticCloud() {
    return (
      window.location.host === 'auto-refi-sb.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-perf.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-dev.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-qa.clouddqt.capitalone.com'
    );
  },
  isProdEnv: window.location.hostname === 'autorefi.capitalone.com',
};
